var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResourceTable',{attrs:{"schema":_vm.schema,"rows":_vm.filteredRows,"headers":_vm.$attrs.headers,"group-by":_vm.$attrs.groupBy,"loading":_vm.loading,"use-query-params-for-simple-filtering":_vm.useQueryParamsForSimpleFiltering,"force-update-live-and-delayed":_vm.forceUpdateLiveAndDelayed}})
}
var staticRenderFns = []

export { render, staticRenderFns }